import { inject, Injectable } from '@angular/core';
import Keycloak from 'keycloak-js';

@Injectable({
  providedIn: 'root'
})

export class AuthenticationService {

  private readonly keycloak = inject(Keycloak);
  
  logout(): void {
    this.keycloak.logout();
  }

  getKeycloakId(): string {
    return this.keycloak.idTokenParsed?.sub ?? '';
  }

  getRealmRoles(): string[] {
    return this.keycloak.realmAccess?.roles || [];
  }

  getSubRoles(): string[] {
    const resource = this.keycloak.resourceAccess || {}; 
    console.log('keycloack', resource['quelix-backend-backoffice'].roles);
    console.log('keycloak tutte le info', this.keycloak);
    return resource['quelix-backend-backoffice'].roles || [];
  } 

  hasRole(role: string): boolean {
    return this.getRealmRoles().includes(role);
  }

  getTenant(){
    console.log('tenant', this.keycloak.tokenParsed?.['quelix-tenant']);
    return this.keycloak.tokenParsed?.['quelix-tenant'];
  }
}
